<template>
  <div class="recipe-hero" :style="{ backgroundImage: `url(${image})` }">
    <div class="recipe-overlay">
      <h2 class="recipe-title">{{ title }}</h2>
    </div>
  </div>
</template>

<script>
export default {
  name: "RecipeHero",
  props: {
    image: {
      type: String,
      required: true,
    },
    title: {
      type: String,
      required: true,
    },
    author: {
      type: String,
      required: true,
    },
  },
};
</script>

<style scoped>
.recipe-hero {
  width: 100%;
  height: 300px;
  background-size: cover;
  background-position: center;
  position: relative;
}

.recipe-overlay {
  background: linear-gradient(transparent, rgba(0, 0, 0, 0.7));
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  padding: 20px;
  color: white;
}

.recipe-title {
  font-size: 1.8rem;
  margin-bottom: 8px;
  font-weight: 600;
}

.recipe-meta {
  display: flex;
  gap: 16px;
  font-size: 0.9rem;
  opacity: 0.9;
}

.recipe-meta span {
  display: flex;
  align-items: center;
  gap: 4px;
}
</style>
